import { normalizeElement } from './normalize-element'

export const normalizeCampaign = (rawData) => {
  const {
    uid = '', // campaign id
    landing_type: landingType = '', // api | web
    expose_type: exposeType = '', // enter | resume | leave | after_watch
    element_list: elementList = [],
  } = rawData

  return {
    uid,
    landingType,
    exposeType,
    elementList: elementList.map(normalizeElement),
  }
}
